<template>
  <div class="col l4 m6 s12">
      <div class="card z-depth-2">
         <div class="card-image">
          <img v-if="data.course.photo_full_path==null" src="https://pngimage.net/wp-content/uploads/2018/05/course-png-6.png" />
          <img v-else :src="data.course.photo_full_path" />
        </div>
        <div class="card-content">
            <div class="row">
              <div class="col l10 m10 s10">
                <p class="header">{{ data.course.name }}</p>
                <p>{{ data.name }}</p>
              </div>
              <div class="col l2 m2 s2" >
                <router-link :to="'/class/'+data.id" class="btn btn-small" href="#"><i class="material-icons">arrow_forward</i></router-link>  
              </div>
            </div>
            
            
        </div>
        
        
      </div>
    </div>
</template>
<script>
export default {
    props:["data"],
}
</script>
<style lang="scss" scoped>
    @import "@/style/colors.scss";

.card 
{
  border-radius: 20px;
}

.card-action a 
{
    background:$primaryColor !important;
    color:white;
}

.card-content 
{
  
  padding-top:10px;
  padding-bottom:0.2px !important;
  padding-left:15px;
  
}

.card-image  img
{
  height:200px;
  border-radius: 20px 20px 0px 0px;
}

.card-content p 
{
  font-size:14px;
}
.card-content .header 
{
  font-weight: 600;
  font-size:14px;
  
}

.card:hover 
{
  transform: translateY(-20px);
  transition: 3s;
}


</style>